import './assets/styles/global.scss';
import './i18n';

import Header from './components/header/Header';
import About from './components/about/About';
import Review from './components/review/Review';
import Contact from './components/contacts/Contacts';
import Footer from './components/footer/Footer';
import HeaderContent from './components/headerContent/HeaderContent';
import Legal from "./pages/legal/Legal.jsx";
//import Education from './pages/education/Education.jsx';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <div id="home"><Header /></div>
              <HeaderContent />
              <div id="about"><About /></div>
              <div id="reviews"><Review /></div>
              <div id="contacts"><Contact /></div>
              <Footer />
            </>
          } />
          <Route path="/legal" element={<Legal />} />
          {/* <Route path="/education" element={<Education />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;